<template>
    <!-- 页面跳转加载效果 -->
    <div v-if="isRequesting" class="modal-loading">
        <div class="modal-loading-content">
            <svg class="loading-skeleton" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M663.2 251.3l-75.7 130.5c-22.2-12.8-48-20.3-75.5-20.3-3.1 0-6 0.3-9 0.5l-11.3-186-130.9 75.3 75.7 130.5c-25.6 14.7-46.3 36.6-59.6 63l-167.3-83.3V512h151.2c0 30.7 9.3 59.1 25.1 82.9l-156 102.5 130.9 75.3 75.7-130.5c22.2 12.8 48 20.3 75.5 20.3 3.1 0 6-0.3 9-0.5l11.3 186 130.9-75.3-75.7-130.5c25.6-14.7 46.3-36.6 59.6-63l167.3 83.3V512H663.2c0-30.7-9.3-59.1-25.1-82.9l156-102.6-130.9-75.2zM512 587.3c-41.8 0-75.6-33.7-75.6-75.3s33.8-75.3 75.6-75.3 75.6 33.7 75.6 75.3-33.8 75.3-75.6 75.3z"
                    fill="currentColor"></path>
                <path
                    d="M64 64v896h896V64H64z m100.8 67.2c18.6 0 33.6 15 33.6 33.6s-15 33.6-33.6 33.6-33.6-15-33.6-33.6 15-33.6 33.6-33.6z m0 761.6c-18.6 0-33.6-15-33.6-33.6s15-33.6 33.6-33.6 33.6 15 33.6 33.6-15 33.6-33.6 33.6z m694.4 0c-18.6 0-33.6-15-33.6-33.6s15-33.6 33.6-33.6 33.6 15 33.6 33.6-15 33.6-33.6 33.6z m-347.2 0c-210.3 0-380.8-170.5-380.8-380.8S301.7 131.2 512 131.2 892.8 301.7 892.8 512 722.3 892.8 512 892.8z m347.2-694.4c-18.6 0-33.6-15-33.6-33.6s15-33.6 33.6-33.6 33.6 15 33.6 33.6-15 33.6-33.6 33.6z"
                    fill="currentColor"></path>
            </svg>
            <div class="loading-text">{{ t("message.Loading") }}</div>
        </div>
    </div>
    <Transition name="modal">
        <div v-if="visible" class="modal-overlay" @click="onClose">
            <Transition name="slide-up">
                <div class="modal-content" @click.stop>
                    <div class="modal-header-top">


                        <div class="modal-header">
                            <Transition name="fade-slide" mode="out-in">
                                <button v-if="view === 'chains'" key="back-btn" type="button" class="back-btn"
                                    @click="backToMethods">
                                    <img class="back-icon" src="@/components/payMent/img/arrow-right.svg" alt="<" />
                                </button>
                            </Transition>
                            <Transition name="fade-slide" mode="out-in">
                                <h2 v-if="view === 'methods'" key="methods-title" class="modal-title">Select Payment
                                    Method:</h2>
                                <h2 v-else key="chains-title" class="modal-title">Select Chain:</h2>
                            </Transition>
                        </div>
                        <div class="close-btn" @click="onClose">
                            <img src="@/assets/icon/close.svg" alt="关闭" />
                        </div>
                    </div>
                    <!-- 内容区域容器 -->
                    <div class="content-container">
                        <!-- 支付方式列表 -->
                        <Transition name="slide-horizontal" mode="out-in">
                            <div v-if="view === 'methods'" key="methods" class="methods-grid">
                                <button v-for="(m, index) in renderMethods" :key="m.id || index" class="method-item"
                                    :class="{ full: index === 0 }" type="button" @click="onSelectMethod(m)">
                                    <span class="left">
                                        <span class="icon-wrapper">
                                            <img v-if="m.icon" :src="m.icon" :alt="m.name" />
                                            <span v-else class="icon-text">{{ m.name }}</span>
                                        </span>
                                        <span class="name">{{ m.name }}</span>
                                    </span>
                                    <img class="chevron" src="@/components/payMent/img/arrow-right.svg" alt=">" />
                                </button>
                            </div>

                            <!-- 链列表 -->
                            <div v-else key="chains" class="chains-list">
                                <button v-for="(c, idx) in (selectedMethod?.chains || [])" :key="c.id || idx"
                                    class="chain-item" type="button" @click="onSelectChain(c)">
                                    <span class="left">
                                        <span class="icon-wrapper">
                                            <img v-if="c.icon || selectedMethod?.icon"
                                                :src="c.icon || selectedMethod?.icon" :alt="chainName(c)" />
                                            <span v-else class="icon-text">{{ chainName(c) }}</span>
                                        </span>
                                        <span class="name">{{ chainName(c) }}</span>
                                    </span>
                                    <span class="token">{{ chainToken() }}</span>
                                </button>
                            </div>
                        </Transition>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script setup>
import { computed, defineEmits, defineProps, ref } from 'vue';
import { useConfigStore } from '@/store/config';
import { createInvoice } from '@/components/payMent/payment';
import { getCacheV1, getUrl, setCacheV1, openExternalLink } from "@/utils/common";
import { useI18n } from 'vue-i18n';
const configStore = useConfigStore();
const { t } = useI18n();

const props = defineProps({
    visible: {
        type: Boolean,
        default: false
    },
    sku_id: {
        type: Number,
        default: 0
    },
    content_type: {
        type: Number,
        default: 1
    }
});

const emit = defineEmits(['close', 'select']);
const renderMethods = computed(() => configStore.invoice_list);

const onClose = () => {
    emit('close');
    // 重置视图，避免下次打开还停留在链列表
    view.value = 'methods';
    selectedMethod.value = null;
};

// 视图状态：methods（方式列表）/ chains（网络列表）
const view = ref('methods');
const selectedMethod = ref(null);

const onSelectMethod = (method) => {
    const chains = Array.isArray(method?.chains) ? method.chains : [];
    if (chains.length > 1) {
        selectedMethod.value = method;
        view.value = 'chains';
        return;
    }
    if (chains.length === 1) {
        // 单链：直接发起请求
        startInvoice(method, chains[0]);
        return;
    }
    // 没有链信息，直接按方式发起
    startInvoice(method, null);
};

const onSelectChain = (chain) => {
    // 多链选择后：发起请求
    startInvoice(selectedMethod.value, chain);
};

const backToMethods = () => {
    view.value = 'methods';
    selectedMethod.value = null;
};

const chainName = (chain) => chain?.name || chain?.network || chain?.chain_name || chain?.id || 'Unknown';
// 右侧展示代币名，如：USDT。优先取支付方式的 name。
const chainToken = () => selectedMethod.value?.name || selectedMethod.value?.token?.toUpperCase() || 'USDT';

// 发起创建发票请求
const isRequesting = ref(false);
const startInvoice = async (method, chain) => {
    let invoice_cache_key = `payment_${props.sku_id}_${chain.chain}_${method.token}`;
    if (getCacheV1(invoice_cache_key)) {
        openExternalLink(getUrl(getCacheV1(invoice_cache_key), invoice_cache_key), { useSelf: true });
        return;
    }
    if (isRequesting.value) return;
    try {
        isRequesting.value = true;
        const params = {
            content_type: props.content_type,
            id: props.sku_id,
            token: method?.token,
            chain: chain?.chain
        };
        const res = await createInvoice(params);

        if (res && res.code === 200) {
            if (method.token == "stars") {
                // 浏览器环境：直接打开支付链接
                openExternalLink(res.data.crypto_address || res.data.url);
                // 浏览器中无法监听支付状态，需要用户手动刷新或通过轮询检查
                setTimeout(async () => {
                    window.location.reload(); // 刷新页面
                }, 1500);
                return;
            }
            const data = res.data;
            setCacheV1(invoice_cache_key, data.invoice_id, 30);
            const url = getUrl(data.invoice_id, invoice_cache_key);
            if (url) {
                openExternalLink(url, { useSelf: true });
            }
        } else {
            console.error('createInvoice failed:', res);
        }
    } catch (error) {
        console.error('createInvoice error:', error);
    } finally {
        isRequesting.value = false;
    }
};
</script>

<style lang="scss" scoped>
.modal-overlay {
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    z-index: 1000;
}

.modal-content {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 20px 20px 0 0;
    padding: 20px 16px 50px;
    width: 100%;
    max-width: 420px;
    position: relative;
    box-shadow: 0 -10px 40px rgba(0, 0, 0, 0.1), 0 8px 32px rgba(0, 0, 0, 0.08);
}

.modal-header-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.close-btn {
    position: relative;
    transform: translateY(-6px);
    width: 24px;
    height: 24px;
    cursor: pointer;
    border-radius: 50%;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: rgba(0, 0, 0, 0.05);
        transform: scale(1.1);
    }

    &:active {
        transform: scale(0.95);
        background: rgba(0, 0, 0, 0.1);
    }

    img {
        width: 100%;
        height: 100%;
        transition: opacity 0.2s ease;
    }
}

.modal-header {
    text-align: left;
    margin: 6px 0 14px;
    display: flex;
    align-items: center;
}

.modal-title {
    font-size: 16px;
    font-weight: 700;
    color: #1b1b1b;
}

.back-btn {
    -webkit-appearance: none;
    appearance: none;
    border: none;
    outline: none;
    background: transparent;
    box-shadow: none;
    width: 28px;
    height: 28px;
    margin-right: 6px;
    border-radius: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;

    &:hover {
        background: rgba(0, 0, 0, 0.05);
    }
}

.back-icon {
    width: 18px;
    height: 18px;
    transform: rotate(180deg);
    opacity: 0.7;
}

.methods-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.method-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f7f8fa;
    border: 1px solid #edf0f5;
    border-radius: 12px;
    padding: 12px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: left;
    transform: translateZ(0); // 启用硬件加速

    &.full {
        grid-column: 1 / -1;
    }

    &:hover {
        background: #f0f2f5;
        border-color: #d1d5db;
        transform: translateY(-1px) translateZ(0);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    &:active {
        transform: translateY(0) scale(0.98) translateZ(0);
        transition-duration: 0.1s;
    }
}

.left {
    display: inline-flex;
    align-items: center;
    gap: 10px;
}

.icon-wrapper {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    img {
        width: 20px;
        height: 20px;
        object-fit: contain;
    }

    .icon-text {
        font-size: 14px;
        font-weight: 700;
        color: #333;
    }
}

.name {
    font-size: 14px;
    font-weight: 700;
    color: #1b1b1b;
}

.chevron {
    width: 18px;
    height: 18px;
    opacity: 0.5;
}

.chains-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.chain-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #f7f8fa;
    border: 1px solid #edf0f5;
    border-radius: 12px;
    padding: 12px;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    text-align: left;

    &:hover {
        background: #f0f2f5;
        border-color: #d1d5db;
    }
}

.token {
    font-size: 12px;
    font-weight: 700;
    color: #98a2b3;
}

// 内容区域容器样式
.content-container {
    position: relative;
    overflow: hidden; // 防止动画过程中出现滚动条
    min-height: 200px; // 保持最小高度，避免闪烁
}

// 标题和返回按钮的淡入淡出动画
.fade-slide-enter-active {
    transition: all 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.fade-slide-leave-active {
    transition: all 0.2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
}

.fade-slide-enter-from {
    opacity: 0;
    transform: translateY(-10px);
}

.fade-slide-leave-to {
    opacity: 0;
    transform: translateY(10px);
}

.fade-slide-enter-to,
.fade-slide-leave-from {
    opacity: 1;
    transform: translateY(0);
}

// 水平切换动画
.slide-horizontal-enter-active {
    transition: all 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.slide-horizontal-leave-active {
    transition: all 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.slide-horizontal-enter-from {
    opacity: 0;
    transform: translateX(30px) scale(0.95);
}

.slide-horizontal-leave-to {
    opacity: 0;
    transform: translateX(-30px) scale(0.95);
}

.slide-horizontal-enter-to,
.slide-horizontal-leave-from {
    opacity: 1;
    transform: translateX(0) scale(1);
}

// 模态框背景淡入淡出动画（优化版）
.modal-enter-active,
.modal-leave-active {
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.modal-enter-from {
    opacity: 0;
    backdrop-filter: blur(0px);
}

.modal-leave-to {
    opacity: 0;
    backdrop-filter: blur(0px);
}

.modal-enter-to,
.modal-leave-from {
    opacity: 1;
    backdrop-filter: blur(10px);
}

// 内容区域从底部弹出动画（优化版）
.slide-up-enter-active {
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.1);
}

.slide-up-leave-active {
    transition: all 0.3s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}

.slide-up-enter-from {
    transform: translateY(100%) scale(0.95);
    opacity: 0.8;
}

.slide-up-leave-to {
    transform: translateY(100%) scale(0.95);
    opacity: 0.8;
}

.slide-up-enter-to,
.slide-up-leave-from {
    transform: translateY(0) scale(1);
    opacity: 1;
}

/* 页面跳转加载效果样式 */
.modal-loading {
    position: fixed;
    z-index: 9999;
    inset: 0;
    background: rgba(40, 40, 40, 0.55);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(2px);
}

.modal-loading-content {
    padding: 6vw 8vw;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.loading-skeleton {
    width: 26vw;
    height: 26vw;
    color: #e5e5e5;
    animation: skeleton-loading 1.5s infinite linear;
}

.loading-text {
    color: #fff;
    font-size: 18px;
    margin-top: 8px;
}

@keyframes skeleton-loading {
    0% {
        color: #cfcfcf;
    }

    50% {
        color: #f0f0f0;
    }

    100% {
        color: #cfcfcf;
    }
}

// 全屏Loading模态框样式
.loading-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(15px);
    -webkit-backdrop-filter: blur(15px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000; // 确保在支付模态框之上
}

// Loading模态框动画
.loading-modal-enter-active,
.loading-modal-leave-active {
    transition: all 0.3s ease;
}

.loading-modal-enter-from,
.loading-modal-leave-to {
    opacity: 0;
    backdrop-filter: blur(0px);
}

.loading-modal-enter-to,
.loading-modal-leave-from {
    opacity: 1;
    backdrop-filter: blur(4px);
}
</style>
